"use client";
import React, { useContext, useMemo } from "react";

import { useAuthQuery } from "@stadium/services/apollo-client";

import { GetUserConfigDocument, GetUserConfigQuery } from "@stadium/shared/src/graphql/operations";

const defaultObj = {};
type UserConfigContextValue = { shopInfo: GetUserConfigQuery["user"]; loading: boolean };

export const UserConfigContext = React.createContext<UserConfigContextValue>(
  defaultObj as UserConfigContextValue,
);

export const useUserConfigContextContext = () => useContext(UserConfigContext);

export const UserConfigProvider = ({ children }) => {
  const { data, loading } = useAuthQuery(GetUserConfigDocument, {
    fetchPolicy: "cache-and-network",
  });

  const value = useMemo(
    () => ({
      shopInfo: data?.user,
      loading,
    }),
    [data, loading],
  );
  return <UserConfigContext.Provider value={value}>{children}</UserConfigContext.Provider>;
};
